module.exports = __webpack_public_path__ + "static/img/twitter.438efa0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/external-profiles/twitter.png
// module id = QooH
// module chunks = 7